import React, { Component } from 'react';
import './Rooms.css';
import ScrollAnimation from 'react-animate-on-scroll';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import room1 from './pokoj 1.jpg';
import room3 from './pokoj 3.jpg';
import room4 from './pokoj 4.jpg';
import room5 from './pokoj 5.jpg';
import room6 from './pokoj 6.jpg';
import room7 from './pokoj 7.jpg';
import room8 from './pokoj 8.jpg';
import bath1 from './lazienka 1.jpg';
import bath3 from './lazienka 3.jpg';
import bath4 from './lazienka 4.jpg';
import bath5 from './lazienka 5.jpg';
import bath6 from './lazienka 6.jpg';
import bath7 from './lazienka 7.jpg';
import bath8 from './lazienka 8.jpg';
import Content from '../Content/Content';



class RoomsTemp extends Component {
    componentDidMount() {
      document.querySelector('.back').addEventListener('click', () => {
        document.querySelector('.back').click();
      })
      document.querySelector('.next').addEventListener('click', () => {
        document.querySelector('.next').click();
      })
    }
    render() {
    const btns = {
        position: `absolute`,
        zIndex: `99`,
        top: `50%`,
        height: `50px`,
        width: `50px`,
        paddingBottom: `5px`,
        color: `#fff`,
        border: `0px`,
        borderRadius: `50%`
    }
      return (
        <Content>
            <ScrollAnimation animateIn="fadeInDown" animateOnce="true">
                <h1 style={{marginBottom: `2em`}}>Pokoje</h1>
                </ScrollAnimation>
            <CarouselProvider
            naturalSlideWidth={50}
            naturalSlideHeight={1}
            totalSlides={14}
            visibleSlides={2}
            infinite={true}
            className="CP"
            dragStep={2}
            >
            <Slider style={{marginBottom:`6em`}}>
                <Slide className="room-gal" index={0}><img src={room1}/></Slide>
                <Slide className="room-gal" index={0}><img src={bath1}/></Slide>
                <Slide className="room-gal" index={2}><img src={room3}/></Slide>
                <Slide className="room-gal" index={0}><img src={bath3}/></Slide>
                <Slide className="room-gal" index={3}><img src={room4}/></Slide>
                <Slide className="room-gal" index={0}><img src={bath4}/></Slide>
                <Slide className="room-gal" index={4}><img src={room5}/></Slide>
                <Slide className="room-gal" index={0}><img src={bath5}/></Slide>
                <Slide className="room-gal" index={5}><img src={room6}/></Slide>
                <Slide className="room-gal" index={0}><img src={bath6}/></Slide>
                <Slide className="room-gal" index={6}><img src={room7}/></Slide>
                <Slide className="room-gal" index={0}><img src={bath7}/></Slide>
                <Slide className="room-gal" index={7}><img src={room8}/></Slide>
                <Slide className="room-gal" index={0}><img src={bath8}/></Slide>
            </Slider>
            <ButtonBack className="back" style={btns}>{"<"}</ButtonBack>
            <ButtonNext className="next" style={btns}>{">"}</ButtonNext>
            </CarouselProvider>
      </Content>
      )
    }
  }

export default RoomsTemp;


// WEBPACK FOOTER //
// ./src/Rooms/RoomsTemp.js